<template>
  <div class="sales-summary">
    <span id="top" />
    <!-- <div class="select-types">
      <div><a href="#order-type-sales">Order Type Sales</a></div>
      <div><a href="#total-sales">Total Sales</a></div>
      <div><a href="#qraved">Qraved</a></div>
      <div><a href="#pos">POS</a></div>
      <div><a href="#qraved-menu">Qraved</a></div>
      <div><a href="#pos-menu">POS</a></div>
      <div><a href="#top">Back To Top</a></div>
    </div> -->
    <h4 class="setTittle">
      <span class="title">
        Sales Report
      </span>
      <div v-if="loading" class="report-loading">
        <b-spinner class="ml-2" variant="danger" />
      </div>
      <b-button
        class="export-button"
        variant="success"
        :disabled="isFetchingDownloadData"
        @click="exportHandle"
      >
        Export
        <b-spinner v-if="isFetchingDownloadData" class="ml-2" small />
      </b-button>
      <b-button
        class="export-button"
        variant="success"
        style="margin-right:10px"
        @click="printHandle"
      >
        Print
      </b-button>
    </h4>
    <label style="margin-top:20px">
      Outlet
    </label>
    <div>
      <b-form-checkbox v-model="selectAll" :indeterminate="indeterminate">
        Select All
      </b-form-checkbox>
      <div class="select-area" :style="{height:!showAllButton?'auto':showAll?'auto':''}">
        <b-form-checkbox-group id="select-group" v-model="selected">
          <b-form-checkbox
            v-for="item in options"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </div>
      <div
        v-if="showAllButton"
        class="show-all-outlet"
        @click="toggleShowALLHandle"
      >
        {{ showAll?'HIDE':'SHOW' }} ALL
      </div>
    </div>
    <DateFilter
      :start-date="date.startDate"
      :end-date="date.endDate"
      :limit-days="$store.state.currentUser.Type === 'Merchant OPS' ? 31 : 7"
      @filtered-dates="updateData"
      @reset-filter="resetData"
    />
    <div id="table-area">
      <div class="sales-tables">
        <h5 id="order-type-sales">Order Type Sales</h5>
        <b-table
          bordered
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="orderTypeFields"
          :items="salesSummaryData.OrderTypeCount?salesSummaryData.OrderTypeCount.SalesSummaryOrderTypeCount:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template slot="OrderType" slot-scope="OrderType">
            {{ OrderType.item.OrderType }}
          </template>
          <template slot="Quantity" slot-scope="Quantity">
            {{ Quantity.item.Quantity }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template
            slot="FOOT_Index"
          >
            {{ salesSummaryData.OrderTypeCount&&salesSummaryData.OrderTypeCount.footer.index }}
          </template>
          <template slot="FOOT_OrderType" />
          <template
            slot="FOOT_Quantity"
          >
            {{ salesSummaryData.OrderTypeCount&&salesSummaryData.OrderTypeCount.footer.Quantity }}
          </template>
          <template
            slot="FOOT_Total"
          >
            Rp. {{ formatPrice(salesSummaryData.OrderTypeCount&&salesSummaryData.OrderTypeCount.footer.Total) }}
          </template>
        </b-table>
      </div>
      <div class="sales-tables">
        <h5 id="total-sales">Total Sales</h5>
        <b-table
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="totalSalesFields"
          :items="salesSummaryData.PaymentTypeCount?salesSummaryData.PaymentTypeCount.SalesSummaryPaymentTypeCount:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template
            slot="DeliveryFee"
            slot-scope="DeliveryFee"
          >
            Rp. {{ formatPrice(DeliveryFee.item.DeliveryFee) }}
          </template>
          <template
            slot="Discount"
            slot-scope="Discount"
          >
            Rp. {{ formatPrice(Discount.item.Discount) }}
          </template>
          <template
            slot="ServiceFee"
            slot-scope="ServiceFee"
          >
            Rp. {{ formatPrice(ServiceFee.item.ServiceFee) }}
          </template>
          <template
            slot="Subtotal"
            slot-scope="Subtotal"
          >
            Rp. {{ formatPrice(Subtotal.item.Subtotal) }}
          </template>
          <template slot="Tax" slot-scope="Tax">
            Rp. {{ formatPrice(Tax.item.Tax) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template
            slot="FOOT_Index"
          >
            {{ salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.index }}
          </template>
          <template
            slot="FOOT_PaymentMethod"
          >
            {{ salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.PaymentMethod }}
          </template>
          <template
            slot="FOOT_Quantity"
          >
            {{ salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.Quantity }}
          </template>
          <template
            slot="FOOT_Subtotal"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.Subtotal) }}
          </template>
          <template
            slot="FOOT_Tax"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.Tax) }}
          </template>
          <template
            slot="FOOT_DeliveryFee"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.DeliveryFee) }}
          </template>
          <template
            slot="FOOT_Discount"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.Discount) }}
          </template>
          <template
            slot="FOOT_ServiceFee"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.ServiceFee) }}
          </template>
          <template
            slot="FOOT_Total"
          >
            Rp. {{ formatPrice(salesSummaryData.PaymentTypeCount&&salesSummaryData.PaymentTypeCount.footer.Total) }}
          </template>
        </b-table>
      </div>
      <div class="sales-tables">
        <h5 id="qraved">Qraved</h5>
        <b-table
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="totalSalesFields"
          :items="salesSummaryData.QravedPaymentTypeCount?salesSummaryData.QravedPaymentTypeCount.SalesSummaryPaymentTypeCount:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template
            slot="DeliveryFee"
            slot-scope="DeliveryFee"
          >
            Rp. {{ formatPrice(DeliveryFee.item.DeliveryFee) }}
          </template>
          <template
            slot="Discount"
            slot-scope="Discount"
          >
            Rp. {{ formatPrice(Discount.item.Discount) }}
          </template>
          <template
            slot="ServiceFee"
            slot-scope="ServiceFee"
          >
            Rp. {{ formatPrice(ServiceFee.item.ServiceFee) }}
          </template>
          <template
            slot="Subtotal"
            slot-scope="Subtotal"
          >
            Rp. {{ formatPrice(Subtotal.item.Subtotal) }}
          </template>
          <template slot="Tax" slot-scope="Tax">
            Rp. {{ formatPrice(Tax.item.Tax) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template
            slot="FOOT_Index"
          >
            {{ salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.index }}
          </template>
          <template
            slot="FOOT_PaymentMethod"
          >
            {{ salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.PaymentMethod }}
          </template>
          <template
            slot="FOOT_Quantity"
          >
            {{ salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.Quantity }}
          </template>
          <template
            slot="FOOT_Subtotal"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.Subtotal) }}
          </template>
          <template
            slot="FOOT_Tax"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.Tax) }}
          </template>
          <template
            slot="FOOT_DeliveryFee"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.DeliveryFee) }}
          </template>
          <template
            slot="FOOT_Discount"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.Discount) }}
          </template>
          <template
            slot="FOOT_ServiceFee"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.ServiceFee) }}
          </template>
          <template
            slot="FOOT_Total"
          >
            Rp. {{ formatPrice(salesSummaryData.QravedPaymentTypeCount&&salesSummaryData.QravedPaymentTypeCount.footer.Total) }}
          </template>
        </b-table>
      </div>
      <div class="sales-tables">
        <h5 id="pos">POS</h5>
        <b-table
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="totalSalesFields"
          :items="salesSummaryData.PosPaymentTypeCount?salesSummaryData.PosPaymentTypeCount.SalesSummaryPaymentTypeCount:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template
            slot="DeliveryFee"
            slot-scope="DeliveryFee"
          >
            Rp. {{ formatPrice(DeliveryFee.item.DeliveryFee) }}
          </template>
          <template
            slot="Discount"
            slot-scope="Discount"
          >
            Rp. {{ formatPrice(Discount.item.Discount) }}
          </template>
          <template
            slot="ServiceFee"
            slot-scope="ServiceFee"
          >
            Rp. {{ formatPrice(ServiceFee.item.ServiceFee) }}
          </template>
          <template
            slot="Subtotal"
            slot-scope="Subtotal"
          >
            Rp. {{ formatPrice(Subtotal.item.Subtotal) }}
          </template>
          <template slot="Tax" slot-scope="Tax">
            Rp. {{ formatPrice(Tax.item.Tax) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template slot="Total" slot-scope="Total">
            Rp. {{ formatPrice(Total.item.Total) }}
          </template>
          <template
            slot="FOOT_Index"
          >
            {{ salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.index }}
          </template>
          <template
            slot="FOOT_PaymentMethod"
          >
            {{ salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.PaymentMethod }}
          </template>
          <template
            slot="FOOT_Quantity"
          >
            {{ salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.Quantity }}
          </template>
          <template
            slot="FOOT_Subtotal"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.Subtotal) }}
          </template>
          <template
            slot="FOOT_Tax"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.Tax) }}
          </template>
          <template
            slot="FOOT_DeliveryFee"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.DeliveryFee) }}
          </template>
          <template
            slot="FOOT_Discount"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.Discount) }}
          </template>
          <template
            slot="FOOT_ServiceFee"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.ServiceFee) }}
          </template>
          <template
            slot="FOOT_Total"
          >
            Rp. {{ formatPrice(salesSummaryData.PosPaymentTypeCount&&salesSummaryData.PosPaymentTypeCount.footer.Total) }}
          </template>
        </b-table>
      </div>
      <div class="sales-tables">
        <h5 id="qraved-menu">Qraved</h5>
        <b-table
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="menuItemFields"
          :items="menuSalesData.qraved?menuSalesData.qraved.summaryMenu:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template slot="quantity" slot-scope="quantity">
            {{ quantity.item.quantity }}
          </template>
          <template slot="variants" slot-scope="variants">
            <div class="break-word">
              {{ variants.item.variants }}
            </div>
          </template>
          <template slot="menuGroupName" slot-scope="menuGroupName">
            <div class="break-word">
              {{ menuGroupName.item.menuGroupName }}
            </div>
          </template>
          <template slot="sales" slot-scope="sales">
            Rp. {{ formatPrice(sales.item.sales) }}
          </template>
          <template slot="FOOT_Index">
            {{ menuSalesData.qraved&&menuSalesData.qraved.footer.index }}
          </template>
          <template slot="FOOT_menuGroupName">
            <div v-show="false" />
          </template>
          <template slot="FOOT_menuName">
            <div v-show="false" />
          </template>
          <template slot="FOOT_variants">
            <div v-show="false" />
          </template>
          <template
            slot="FOOT_quantity"
          >
            {{ menuSalesData.qraved&&menuSalesData.qraved.footer.quantity }}
          </template>
          <template
            slot="FOOT_sales"
          >
            Rp. {{ formatPrice(menuSalesData.qraved&&menuSalesData.qraved.footer.sales) }}
          </template>
        </b-table>
      </div>

      <div class="sales-tables">
        <h5 id="pos-menu">POS</h5>
        <b-table
          foot-clone
          no-footer-sorting
          class="table"
          responsive
          :fields="menuItemFields"
          :items="menuSalesData.pos?menuSalesData.pos.summaryMenu:[]"
        >
          <template slot="Index" slot-scope="Index">
            {{ Index.index+1+'.' }}
          </template>
          <template slot="quantity" slot-scope="quantity">
            {{ quantity.item.quantity }}
          </template>
          <template slot="variants" slot-scope="variants">
            <div class="break-word">
              {{ variants.item.variants }}
            </div>
          </template>
          <template slot="menuGroupName" slot-scope="menuGroupName">
            <div class="break-word">
              {{ menuGroupName.item.menuGroupName }}
            </div>
          </template>
          <template slot="sales" slot-scope="sales">
            Rp. {{ formatPrice(sales.item.sales) }}
          </template>
          <template slot="FOOT_Index">
            {{ menuSalesData.pos&&menuSalesData.pos.footer.index }}
          </template>
          <template slot="FOOT_menuGroupName">
            <div v-show="false" />
          </template>
          <template slot="FOOT_menuName">
            <div v-show="false" />
          </template>
          <template slot="FOOT_variants">
            <div v-show="false" />
          </template>
          <template slot="FOOT_quantity">
            {{ menuSalesData.pos&&menuSalesData.pos.footer.quantity }}
          </template>
          <template
            slot="FOOT_sales"
          >
            Rp. {{ formatPrice(menuSalesData.pos&&menuSalesData.pos.footer.sales) }}
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from '@/components/DateFilter.vue';
import moment from 'moment';
import api from '@/api';
import { formatNumber } from '@/utils/helpers';
import constants from '@/utils/constants';
const defaultStartDate = moment()
  .subtract(0, 'days')
  .format('YYYY-MM-DD');
const defaultEndDate = moment().format('YYYY-MM-DD');
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      selectAll: false,
      showAllButton: false,
      indeterminate: false,
      selected: [],
      defaultStartDate,
      loading: true,
      defaultEndDate,
      options: [],
      showAll: false,
      isFetchingDownloadData: false,
      formatPrice: function(val) {
        let date = val;
        return formatNumber(date);
      },
      salesSummaryData: {},
      menuSalesData: {},
      totalSalesFields: [
        { key: 'Index', label: '' },
        { key: 'PaymentMethod', label: 'Payment Method' },
        { key: 'Quantity', label: '#Order' },
        { key: 'Subtotal', label: 'Subtotal', sortable: true },
        { key: 'Tax', label: 'Tax', sortable: true },
        { key: 'DeliveryFee', label: 'Delivery Fee', sortable: true },
        { key: 'Discount', label: 'Discount', sortable: true },
        { key: 'ServiceFee', label: 'Service Fee', sortable: true },
        { key: 'Total', label: 'Total Payment', sortable: true }
      ],
      orderTypeFields: [
        { key: 'Index', label: '' },
        { key: 'OrderType', label: 'Order Type' },
        {
          key: 'Quantity',
          label: '#Order',
          sortable: true
        },
        { key: 'Total', label: 'Total Sales', sortable: true }
      ],
      menuItemFields: [
        { key: 'Index', label: '' },
        {
          key: 'menuGroupName',
          label: 'Group Name'
        },
        { key: 'menuName', label: 'Item Name' },
        { key: 'variants', label: 'Variant' },
        { key: 'quantity', label: 'Quantity', sortable: true },
        { key: 'sales', label: 'Sales', sortable: true }
      ],
      date: {
        startDate: defaultStartDate,
        endDate: defaultEndDate
      }
    };
  },
  watch: {
    selected: function(newVal) {
      if (newVal.length && newVal.length < this.options.length) {
        return (this.indeterminate = true);
      }
      if (newVal.length === this.options.length) {
        this.selectAll = true;
        this.indeterminate = false;
      } else {
        this.selectAll = false;
        this.indeterminate = false;
      }
    },
    selectAll: function(newVal) {
      if (newVal) {
        this.selected = this.options.map(item => item.value);
      } else {
        this.selected = [];
      }
    }
  },
  async mounted() {
    const size = 100;
    const uid = localStorage.getItem('UID');
    let outletCodes = localStorage
      .getItem('outletCodes')
      .split(',')
      .filter(item => !!item);
    const renderPage = () => {
      this.selected = this.options.length ? [this.options[0].value] : [];
      this.getData();
      this.$nextTick(() => {
        if (document.getElementById('select-group').clientHeight > 192) {
          this.showAllButton = true;
        } else {
          this.showAllButton = false;
        }
      });
    };

    const getList = async page => {
      await api
        .GetAllStoreForNewPort(
          { page, size },
          { byField: '', isDesc: '' },
          {},
          uid
        )
        .then(res => {
          try {
            const { data, count } = res.data.result;
            if (count <= size) {
              for (let index = 0; index < data.length; index++) {
                const element = data[index];
                this.options.push({
                  value: element.outlet_code,
                  text: element.outlet_code + ' - ' + element.name
                });
              }
              renderPage();
            } else {
              const pageCount = Math.ceil(count / size);
              const promiseArr = [];
              const promiseAll = async () => {
                for (let i = 1; i <= pageCount; i++) {
                  promiseArr.push(
                    new Promise((resolve, reject) => {
                      api
                        .GetAllStoreForNewPort(
                          { page: i, size },
                          { byField: '', isDesc: '' },
                          {},
                          uid
                        )
                        .then(res => {
                          try {
                            const { data } = res.data.result;
                            resolve(data);
                          } catch (error) {
                            throw error;
                          }
                        });
                    })
                  );
                }
                return Promise.all(promiseArr);
              };
              promiseAll().then(res => {
                const newArr = [].concat(...res);
                for (let i = 0; i < newArr.length; i++) {
                  const element = newArr[i];
                  this.options.push({
                    value: element.outlet_code,
                    text: element.outlet_code + ' - ' + element.name
                  });
                }
                renderPage();
              });
            }
          } catch (error) {
            throw error;
          }
        });
    };
    if (outletCodes.length) {
      await getList(1);
    } else {
      this.loading = false;
    }
  },
  methods: {
    toggleShowALLHandle() {
      this.showAll = !this.showAll;
    },
    exportHandle() {
      this.isFetchingDownloadData = true;
      const params = {
        outletCode: this.selected.join(','),
        f_beginDay: moment(this.date.startDate).format('YYYY-MM-DD'),
        f_endDay: moment(this.date.endDate).format('YYYY-MM-DD'),
        page: 1,
        size: 10000
      };
      api
        .ExportSalesReport(params)
        .then(res => {
          const a = document.createElement('a');
          a.setAttribute('download', '');
          a.setAttribute('href', res.data.data.filePath);
          a.click();
          // window.open(res.data.data.filePath);
          this.isFetchingDownloadData = false;
        })
        .catch(err => {
          this.isFetchingDownloadData = false;
          this.$swal(
            constants.SOMETHING_WROING,
            err.response.data.message,
            constants.STATUS_ERROR
          );
        });
    },
    printHandle() {
      const filteredSelected = [];
      const userName = localStorage.getItem('UserName');
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        for (let j = 0; j < this.options.length; j++) {
          const item = this.options[j];
          if (element === item.value) {
            filteredSelected.push(item);
          }
        }
      }
      const outletNames = filteredSelected.map(item => {
        return item.text;
      });
      if (window && typeof android !== 'undefined') {
        android.printSalesReport(
          JSON.stringify({ ...this.salesSummaryData, ...this.menuSalesData }),
          userName,
          outletNames.join(','),
          this.date.startDate,
          this.date.endDate
        );
      }
    },
    getData() {
      this.loading = true;
      const params = {
        outletCode: this.selected.join(','),
        f_beginDay: moment(this.date.startDate).format('YYYY-MM-DD'),
        f_endDay: moment(this.date.endDate).format('YYYY-MM-DD'),
        page: 1,
        size: 10000
      };
      api.GetSalesSummaryCount(params).then(res => {
        this.loading = false;
        if (res.data.invalidMessage !== constants.UPPER_SUCCESS) {
          return this.$swal(
            constants.SOMETHING_WROING,
            res.data.invalidMessage,
            constants.STATUS_ERROR
          );
        }
        const {
          PaymentTypeCount,
          OrderTypeCount,
          PosPaymentTypeCount,
          QravedPaymentTypeCount
        } = res.data.data;
        PaymentTypeCount.footer = {
          index: 'Grand Total',
          DeliveryFee: PaymentTypeCount.DeliveryFee,
          Discount: PaymentTypeCount.Discount,
          ServiceFee: PaymentTypeCount.ServiceFee,
          Subtotal: PaymentTypeCount.Subtotal,
          Tax: PaymentTypeCount.Tax,
          Total: PaymentTypeCount.Total,
          Quantity: PaymentTypeCount.Quantity
        };
        QravedPaymentTypeCount.footer = {
          index: 'Grand Total',
          DeliveryFee: QravedPaymentTypeCount.DeliveryFee,
          Discount: QravedPaymentTypeCount.Discount,
          ServiceFee: QravedPaymentTypeCount.ServiceFee,
          Subtotal: QravedPaymentTypeCount.Subtotal,
          Tax: QravedPaymentTypeCount.Tax,
          Total: QravedPaymentTypeCount.Total,
          Quantity: QravedPaymentTypeCount.Quantity
        };
        PosPaymentTypeCount.footer = {
          index: 'Grand Total',
          DeliveryFee: PosPaymentTypeCount.DeliveryFee,
          Discount: PosPaymentTypeCount.Discount,
          ServiceFee: PosPaymentTypeCount.ServiceFee,
          Subtotal: PosPaymentTypeCount.Subtotal,
          Tax: PosPaymentTypeCount.Tax,
          Total: PosPaymentTypeCount.Total,
          Quantity: PosPaymentTypeCount.Quantity
        };
        OrderTypeCount.footer = {
          index: 'Grand Total',
          Quantity: OrderTypeCount.Quantity,
          Total: OrderTypeCount.Total
        };
        this.salesSummaryData = res.data.data;
      });
      api.GetSalesMenu(params).then(res => {
        const { pos, qraved } = res.data.data;
        pos.footer = {
          index: 'Grand Total',
          menuGroupName: '',
          menuItemCode: '',
          menuName: '',
          quantity: pos.quantity,
          sales: pos.sales,
          variants: ''
        };
        qraved.footer = {
          index: 'Grand Total',
          menuGroupName: '',
          menuItemCode: '',
          menuName: '',
          quantity: qraved.quantity,
          sales: qraved.sales,
          variants: ''
        };
        this.menuSalesData = res.data.data;
      });
    },
    updateData(filteredData) {
      this.date.startDate = filteredData.startDate || defaultStartDate;
      this.date.endDate = filteredData.endDate || defaultEndDate;
      this.getData();
    },
    resetData() {
      this.date.startDate = defaultStartDate;
      this.date.endDate = defaultEndDate;
      this.getData();
    }
  }
};
</script>
